import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { ImageCoverageInsightData, ImageCoverageInsightTotalData, ImageCoverageSortable } from './types';
import { SortOrder } from '../types';
import { getBaseUrl } from '../utils';

export const getImageCoverageInsightForEntity = ({
  entityType,
  entityId,
  sortBy,
  sortOrder,
  cursor,
}: {
  entityType: EntityType;
  entityId: string;
  sortBy: ImageCoverageSortable;
  sortOrder: SortOrder;
  cursor?: string;
}) =>
  merchantGatewayApi
    .get<ImageCoverageInsightData>(`${getBaseUrl(entityType, entityId)}/image-coverage`, {
      params: {
        sort_by: sortBy,
        sort_order: sortOrder,
        cursor,
      },
    })
    .then(response => response.data);

export const getImageCoverageInsightTotalForEntity = ({
  entityType,
  entityId,
}: {
  entityType: EntityType;
  entityId: string;
}) =>
  merchantGatewayApi
    .get<ImageCoverageInsightTotalData>(`${getBaseUrl(entityType, entityId)}/image-coverage/total`)
    .then(response => response.data);
